import { render } from "./form-user.vue?vue&type=template&id=7bf22094"
import script from "./form-user.js?vue&type=script&lang=js&external"
export * from "./form-user.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__